import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=316d971a&"
import script from "./top-menu.vue?vue&type=script&lang=js&"
export * from "./top-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports